const FormResources = {

    form_data:
    {
        daily_assignment_id: [],
        supervisor_id: [],
        shift_id: [],
        shift_class_id: [],
        day_id: '',
        all_assignments: false,
        see_all_rooms: false,
        show_notes: false
    },

    form_format:
    [
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'See all rooms:',
            model_name: 'see_all_rooms',
            ref:        'see_all_rooms_input',
            ref_alt:    'see_all_rooms_input_alt',
            required:   false,
            search: false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Show notes:',
            model_name: 'show_notes',
            ref:        'show_notes_input',
            ref_alt:    'show_notes_input_alt',
            required:   false,
            search: false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'All assignments:',
            model_name: 'all_assignments',
            ref:        'all_assignments_input',
            ref_alt:    'all_assignments_input_alt',
            required:   false,
            search: false,
        },
        {
            css_class:  'col-md-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select assignment(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'supervisor_id',
            ref:        'supervisor_id_input',
            ref_alt:    'supervisor_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select supervisor(s)',
            close_on_option: false,
            track_by: 'associate_name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select shift(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Class Shift:',
            model_name: 'shift_class_id',
            ref:        'shift_class_id_input',
            ref_alt:    'shift_class_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select class shift(s)',
            close_on_option: false,
            track_by: 'name'
        },
        {
            css_class:  'col-md-2',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Day:',
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   false,
            search: false,
        },
        
    ],

}

export default FormResources